import { Inject } from '@odinjs/odin';
import { PanelAPI, PDFViewerAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { ExamReportModalAliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

@Controller({ fragment: FragmentNames.EXAM_REPORT_MODAL })
export default class MyChartSendingDocumentsController extends BaseController {

  @Inject(ExamReportModalAliases.PDF_VIEWER)
    pdfViewerAPI!: PDFViewerAPI;

  @Inject(ExamReportModalAliases.PANEL_LOADER)
    panelLoaderAPI!: PanelAPI;

  @OnMount(ExamReportModalAliases.EXAM_REPORT_MODAL_LAYOUT)
  handleLayoutViewSentDocumentLoading(): void {
    const uri = this.context.get('uri') as string;

    this.panelLoaderAPI.setVisible(false);
    this.pdfViewerAPI.setVisible(true);
    this.pdfViewerAPI.setSrc(uri);
  }
}
